import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum NoodlesMidaboSupplierOrderLineItemKeys {
  position = 'position', // line item number/position, not to be entered by user
  productTitle = 'productTitle', // name of the item, often SKU, Unique ID, refernce ID, etc
  productNumber = 'productNumber', // number for the product
  itemQty = 'itemQty', // quantity of the item for order
  note = 'note', // price per unit
}

export const noodlesMidaboSupplierOrderFileDataSchema = yup.object().shape({
  orderNumber: yup.string().nullable().optional(),
  dateCreated: yup.string().nullable().optional(),
  deliveryDate: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        position: yup.number().nullable().optional(),
        productTitle: yup.string().nullable().optional(),
        productNumber: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        note: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type NoodlesMidaboSupplierOrderFileData = yup.InferType<
  typeof noodlesMidaboSupplierOrderFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<NoodlesMidaboSupplierOrderFileData>

export const noodlesMidaboSupplierOrderFileMappings: RequiredFileData = {
  orderNumber: 'cf920b4b-e24d-452b-bc1f-d2d580c137bc',
  dateCreated: '405de2fe-acde-4e1f-8e95-51a7a39e8cbb',
  deliveryDate: '6ede694c-c457-4e2e-97a4-a22987daf9e3',
  items: [
    {
      position: null,
      productTitle: '651055b9-a387-4260-b494-c30165920a1a',
      productNumber: '8bf38658-33db-4c9b-9de1-468271c0be1b',
      itemQty: 'd31ff020-1bb6-4061-81c1-712829f764ef',
      note: 'a6377adb-8f29-4819-9a0e-8a57ae90dfea',
    },
  ],
}
